import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { loadServiceDetail } from "../services/contentSource";
import ClientBrandsSection from "../components/clientBrandSection";
import Error from "./404";
import Seo from "../components/Seo";

const ServiceDetails = () => {
  const [content, setContent] = useState<any>(null);
  const [missing, setMissing] = useState(false);
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    if (!slug) {
      setMissing(true);
      return;
    }
    let cancelled = false;

    loadServiceDetail(slug).then((detail) => {
      if (cancelled) return;
      if (detail) {
        setContent(detail);
      } else {
        setMissing(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (missing) {
    return <Error />;
  }

  if (!content) {
    return <p>Loading service details...</p>;
  }

  return (
    <>
      <Seo
        title={String(content.title ?? "Service").replace(/<[^>]*>/g, " ").trim()}
        description={String(content.subtitle ?? content.description ?? "Engineering services from MindSyncX Labs.").slice(0, 200)}
        path={`/services/${slug}`}
      />
      <link
        rel="stylesheet"
        href="/assets/css/master-service-details.css"
      ></link>
      <main>
        {/* service details area start */}
        <section className="service-details-area">
          <div className="container">
            <div className="thumb-main">
              <img
                src={content.gallery[0]}
                className="has_fade_anim"
                data-delay="0.30"
                data-fade-offset={0}
                alt="image" loading="lazy" decoding="async" />
              <div className="hero-social">
                <p className="title">Follow</p>
                <div className="hero-social-links">
                  <a href="https://www.youtube.com/@MindSyncX" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                  <a href="https://www.facebook.com/profile.php?id=61577047823875&sk=about" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a href="https://www.x.com/mindsyncx" target="_blank" rel="noopener noreferrer">
                    𝕏
                  </a>
                  <a href="https://www.instagram.com/mindsyncx_labs" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/mindsyncxlabs" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="section-title-box">
              <div className="section-title-wrapper">
                <div className="title-wrapper">
                  <h1
                    className="section-title has_fade_anim"
                    data-on-scroll={0}
                    dangerouslySetInnerHTML={{ __html: content.title }}
                  />
                </div>
              </div>

              <div
                className="feature-list has_fade_anim"
                data-on-scroll={0}
                data-delay="0.45"
              >
                {content.features.map((group: any, i: any) => (
                  <ul key={i}>
                    {group.map((item: any, j: any) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                ))}
              </div>
            </div>

            <div className="text-wrapper has_fade_anim">
              {content.intro.map((text: any, idx: any) => (
                <p className="text" key={idx}>
                  {text}
                </p>
              ))}
            </div>
          </div>

          <div className="steps-wrapper-box has_fade_anim">
            <div className="container">
              <div className="working-steps-box">
                <div className="working-steps">
                  {content.steps.map((step: any, i: any) => (
                    <div className="working-step" key={i}>
                      <h2
                        className="title"
                        dangerouslySetInnerHTML={{ __html: step.title }}
                      />
                      <p className="text">{step.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="container">
            <div className="thumb-gallery has_fade_anim">
              {content.gallery.slice(1).map((img: any, i: any) => (
                <img key={i} src={img} alt="image" loading="lazy" decoding="async" />
              ))}
            </div>
          </div> */}
        </section>
        {/* service details area end */}

        {/* features area start */}
        {/* <div className="features-area">
          <div className="container">
            <div className="features-area-inner section-spacing-top">
              <div className="section-header">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2
                      className="section-title has_fade_anim"
                      dangerouslySetInnerHTML={{
                        __html: content.featureArea.heading,
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="section-content">
                <div className="shape has_fade_anim">
                  <img
                    className="show-light"
                    src={content.featureArea.shape.light}
                    alt="shape" loading="lazy" decoding="async" />
                  <img
                    className="show-dark"
                    src={content.featureArea.shape.dark}
                    alt="shape" loading="lazy" decoding="async" />
                </div>

                <div className="content-last">
                  <div className="thumb has_fade_anim">
                    <img
                      className="main-image"
                      src={content.featureArea.mainImage}
                      alt="image" loading="lazy" decoding="async" />
                    <div className="shape-1">
                      <img src={content.featureArea.shape1} alt="image" loading="lazy" decoding="async" />
                    </div>
                  </div>

                  <div className="text-wrapper has_fade_anim">
                    {content.featureArea.paragraphs.map((text: any, i: any) => (
                      <p className="text" key={i}>
                        {text}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* features area end */}

        {/* faq area start */}
        <section className="faq-area">
          <div className="container">
            <div className="faq-area-inner section-spacing-top">
              <div className="section-content">
                <div className="thumb">
                  <img
                    src={content.faq.thumb}
                    className="has_fade_anim"
                    data-fade-from="left"
                    alt="image" loading="lazy" decoding="async" />
                </div>

                <div className="content-last has_fade_anim">
                  <div className="section-title-wrapper">
                    <div className="title-wrapper">
                      <h2 className="section-title">{content.faq.title}</h2>
                    </div>
                  </div>

                  <div className="accordion-wrapper">
                    <div
                      className="accordion accordion-flush"
                      id="accordionFlushExample"
                    >
                      {content.faq.items.map((item: any, idx: any) => {
                        const id = `flush-${idx}`;
                        return (
                          <div className="accordion-item" key={idx}>
                            <h2
                              className="accordion-header"
                              id={`${id}Heading`}
                            >
                              <button
                                className={`accordion-button ${
                                  idx === 1 ? "" : "collapsed"
                                }`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#${id}Collapse`}
                                aria-expanded={idx === 1}
                                aria-controls={`${id}Collapse`}
                              >
                                {item}
                              </button>
                            </h2>
                            <div
                              id={`${id}Collapse`}
                              className={`accordion-collapse collapse ${
                                idx === 1 ? "show" : ""
                              }`}
                              aria-labelledby={`${id}Heading`}
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div className="accordion-body">
                                {content.faq.answer}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* faq area end */}

        {/* client area start  */}
        <ClientBrandsSection />
        {/* client area end  */}
        
        {/* contact area start  */}
        <section className="contact-area">
          <div className="container">
            <div className="contact-area-inner section-spacing">
              <div className="shape-1">
                <img src="/assets/imgs/shape/img-s-73.webp" alt="shape" loading="lazy" decoding="async" />
              </div>
              <div className="section-content">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2 className="section-title has_fade_anim">
                      Start your experience with MindSyncX
                    </h2>
                  </div>
                </div>
                <div className="btn-wrapper has_fade_anim">
                  <a
                    href="/contact"
                    className="wc-btn wc-btn-underline btn-text-flip"
                  >
                    {" "}
                    <span data-text="Let’s get in touch">
                      Let’s get in touch
                    </span>{" "}
                    <img
                      src="/assets/imgs/icon/arrow-right-half-light.webp"
                      alt="icon image" loading="lazy" decoding="async" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* contact area end  */}
      </main>
    </>
  );
};

export default ServiceDetails;
